module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reveal-set-paid"
  }, [(_vm.invoice.status !== 'PAID') ? _c('reveal', {
    attrs: {
      "confirm": true
    },
    on: {
      "confirm": _vm.setPaid
    }
  }, [(_vm.buttons) ? _c('button', {
    staticClass: "button warning",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Mark as Paid")]) : _c('a', {
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Pay by cash")]), _c('h2', [_vm._v("Do you really want to Mark as Paid the invoice"), _c('strong', [_vm._v("INV" + _vm._s(_vm.invoice.internal_id) + "(" + _vm._s(_vm.invoice.id) + ")")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5063151f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/InvoiceRevealMarkAsPaid.vue
// module id = 2342
// module chunks = 1